import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DataGridView,
  Button,
  Row,
  Col,
} from "@neumetric/blueprint-lib/components";
import { useDispatch, useSelector } from "react-redux";
import { auditorActions, getModelList } from "../../../store";

const PAGE_SIZE = 9;

const Columns = [
  {
    dataIndex: "model_id",
    typeRepresentation: "TEXT",
    title: "Blueprint ID",
    width: "20%",
  },
  {
    dataIndex: "status",
    typeRepresentation: "TEXT",
    title: "Status",
    width: "10%",
    classes: {
      content: "text-caps",
    },
  },
  {
    dataIndex: "title",
    typeRepresentation: "TEXT",
    title: "Title",
    width: "60%",
    showTooltip: true,
    semantics: {
      ellipsisFlag: true,
    },
  },
  {
    dataIndex: "action",
    typeRepresentation: "LINK",
    title: "Action",
    width: "10%",
  },
];

export const AuditorControllerBlueprintScreen = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const modelList = useSelector(getModelList);
  const [page, setPage] = React.useState(1);

  React.useEffect(() => {
    dispatch(auditorActions.fetchModelList());
  }, [dispatch]);

  // reset to page 1 when list changes (or after fetch)
  React.useEffect(() => {
    setPage(1);
  }, [modelList.length]);

  const pagedRows = React.useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return modelList.slice(start, start + PAGE_SIZE).map((m) => ({
      ...m,
      action: "Details",
    }));
  }, [modelList, page]);

  const handleNewBlueprintClick = React.useCallback(() => {
    navigate(`/A/M/new`);
  }, [navigate, location.search, location.pathname]);
  return (
    <Row justify="between" className="h-100">
      <div className="w-55 pl-30 mt-50 h-80">
        <DataGridView
          columns={Columns}
          dataSource={pagedRows}
          rowKey="id"
          pagination={{
            totalCount: modelList.length,
            pageSize: PAGE_SIZE,
            recentFlag: false,
            defaultPage: String(page),
            onPageChange: (nextPage) => setPage(Number(nextPage) || 1),
          }}
          getCellSemantics={(column, record) => {
            if (column.dataIndex === "action") {
              return { onLinkClick: () => navigate(`/A/M/${record.guid}`) };
            }
            return {};
          }}
          EmptyComponent={
            <div className="w-100 h-100 d-flex align-center justify-center">
              <span className="ff-exo2 fs-14 text-placeholder">
                There are no Blueprints!
              </span>
            </div>
          }
        />
      </div>
      <Col className="pr-30 mt-10">
        <Button icon="ADD" label="Create" onClick={handleNewBlueprintClick} />
      </Col>
    </Row>
  );
};
